import {
    postData,
    getData
} from './Services'


export const postLogin= async (body) => {
    const res = await postData('/auth/login', body, true)
    ////console.log("LoginService: ", res)
    return res
}



export const getMe= async (body) => {
    const res = await getData('/auth/me', body, true)
    ////console.log("LoginService: ", res)
    return res
}